import styled from 'styled-components'

export const NotificationAppHeaderContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`

export const ClickOutsideHandler = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`

export const DropdownContainer = styled.div`
    position: relative;
`

// Screen reader announcements container
export const AnnouncementContainer = styled.div`
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border: 0 !important;
`
